import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

const FLAG_ASSETS: Record<string, string> = {
  'Australia': '/images/flags/au.svg',
  'New Zealand': '/images/flags/nz.svg',
  'Samoa': '/images/flags/ws.svg',
  'Cayman Islands': '/images/flags/ky.svg',
  'British Virgin Islands': '/images/flags/vg.svg',
  'Bermuda': '/images/flags/bm.svg',
  'Gibraltar': '/images/flags/gi.svg',
  'Guernsey': '/images/flags/gg.svg',
  'Jersey': '/images/flags/je.svg',
  'Isle of Man': '/images/flags/im.svg',
  'Luxembourg': '/images/flags/lu.svg',
  'Ireland': '/images/flags/ie.svg',
  'Singapore': '/images/flags/sg.svg',
  'Hong Kong': '/images/flags/hk.svg',
  'United Kingdom': '/images/flags/gb.svg',
  'United States': '/images/flags/us.svg',
  'European Union': '/images/flags/eu.svg',
};

const GLOBAL_SVG = `<svg viewBox="0 0 150 100" xmlns="http://www.w3.org/2000/svg">
  <rect width="150" height="100" fill="#1e40af"/>
  <circle cx="75" cy="50" r="38" fill="#3b82f6" stroke="#93c5fd" stroke-width="1.5"/>
  <ellipse cx="75" cy="50" rx="18" ry="38" fill="none" stroke="#93c5fd" stroke-width="1.2"/>
  <ellipse cx="75" cy="50" rx="38" ry="38" fill="none" stroke="#93c5fd" stroke-width="1.2"/>
  <line x1="37" y1="50" x2="113" y2="50" stroke="#93c5fd" stroke-width="1.2"/>
  <ellipse cx="75" cy="50" rx="38" ry="15" fill="none" stroke="#93c5fd" stroke-width="1.2"/>
  <ellipse cx="75" cy="50" rx="38" ry="28" fill="none" stroke="#93c5fd" stroke-width="1"/>
</svg>`;

const GENERIC_SVG = `<svg viewBox="0 0 150 100" xmlns="http://www.w3.org/2000/svg">
  <rect width="150" height="100" fill="#e5e7eb"/>
  <rect width="150" height="100" fill="none" stroke="#9ca3af" stroke-width="4"/>
</svg>`;

@Component({
  selector: 'app-jurisdiction-flag',
  template: `
    <img
      class="inline-flex items-center justify-center overflow-hidden rounded-sm h-4 w-6 flex-shrink-0"
      [src]="flagSrc()"
      alt=""
      aria-hidden="true"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JurisdictionFlagComponent {
  readonly jurisdiction = input.required<string>();

  protected readonly flagSrc = computed((): string => {
    const asset = FLAG_ASSETS[this.jurisdiction()];
    if (asset) return asset;

    const svg = this.jurisdiction() === 'Global' ? GLOBAL_SVG : GENERIC_SVG;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
  });
}
